/**
 * ¿Se muestran los montos sensibles? La preferencia detrás del interruptor
 * «Montos ocultos / visibles» (plan del portal, D5).
 *
 * **Oculto por defecto**: quien abre el portal en una reunión o con alguien al
 * lado no expone su sueldo por olvidarse de apretar algo. Se recuerda entre
 * sesiones en este navegador, como el tema.
 *
 * ⚠️ Protege de miradas por encima del hombro y de una pantalla compartida, **no
 * es seguridad**: el monto llega igual al navegador. Lo que controla quién ve qué
 * sigue siendo el RBAC.
 */
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface MontosState {
  visibles: boolean
  alternar: () => void
}

export const useMontosStore = create<MontosState>()(
  persist(
    (set) => ({
      visibles: false,
      alternar: () => set(s => ({ visibles: !s.visibles })),
    }),
    {
      name: 'clobi-montos',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ visibles: s.visibles }),
    },
  ),
)
